<template>
  <div class="has-text-left">
    <div class="video" v-html="content.primary.video.html"></div>
    <div v-for="(item, i) in content.items" :key="i">
      <h3 :class="`mist-${language}-h3`">{{ item.title[0].text }}</h3>
      <prismic-rich-text
        :class="`mist-${language}-p`"
        :field="item.info"
        style="padding-top: 20px"
      />
    </div>
    <div @click="toPage(content.primary.link_url[0].text)" class="link-btn">
      <img :src="require(`@/assets/img/plus-icon.svg`)" />
      <span :class="`mist-${language}-link`">{{
        content.primary.link_label[0].text
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["content"],
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
  },
  computed: {
    language() {
      return this.$store.getters["language/language"];
    },
  },
};
</script>

<style scoped>
.link-btn {
  align-items: center;
  display: flex;
  cursor: pointer;
  margin-top: 33px;
}

>>> iframe {
  border: 0;
  width: 100%;
  height: 451.89px;
}
.video {
  padding: 30px 0 37px;
}
@media (max-width: 768px) {
  .mist-link {
    font-weight: 600 !important;
  }
  >>> iframe {
    height: 189px;
  }
  .video {
    padding: 24px 0 33px;
  }
}
</style>